import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=a85edca0&"
import script from "./UploadImage.vue?vue&type=script&lang=ts&"
export * from "./UploadImage.vue?vue&type=script&lang=ts&"
import style0 from "./UploadImage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports